var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('router-view')],1),_c('Loader',{attrs:{"dialog-loader":_vm.loadingGlobal,"message":"Cargando..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }